var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.5C0 4.53023 4.03023 0.5 9 0.5C13.9698 0.5 18 4.53023 18 9.5C18 14.4698 13.9698 18.5 9 18.5C4.03023 18.5 0 14.4698 0 9.5Z",
    fill: "#E5AA17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45134 9.49644C1.45134 5.32995 4.83019 1.95109 8.99668 1.95109C13.1632 1.95109 16.542 5.32995 16.542 9.49644C16.542 13.6629 13.1632 17.0418 8.99668 17.0418C4.83019 17.0418 1.45134 13.6629 1.45134 9.49644Z",
    stroke: "white",
    strokeWidth: 0.580411
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35254 7.41145C6.35254 7.10304 6.60255 6.85303 6.91096 6.85303H8.2372C8.5456 6.85303 8.79562 7.10304 8.79562 7.41144V12.3674C8.79562 13.2926 8.04558 14.0427 7.12036 14.0427H6.91096C6.60255 14.0427 6.35254 13.7926 6.35254 13.4842V7.41145Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33105 10.485C9.33105 10.7934 9.58107 11.0435 9.88947 11.0435H10.0989C11.0241 11.0435 11.7741 10.2934 11.7741 9.3682V7.83256C11.7741 7.52415 11.5241 7.27414 11.2157 7.27414H9.88947C9.58107 7.27414 9.33105 7.52415 9.33105 7.83256V10.485Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26092 4.41211C9.56932 4.41211 9.81934 4.66212 9.81934 4.97053L9.81934 6.29677C9.81934 6.60517 9.56932 6.85519 9.26092 6.85519L5.98021 6.85519C5.67181 6.85519 5.4218 6.60517 5.4218 6.29677L5.4218 6.08736C5.4218 5.16215 6.17183 4.41211 7.09705 4.41211L9.26092 4.41211Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1222 6.85522C12.4307 6.85522 12.6807 6.60521 12.6807 6.29681L12.6807 6.0874C12.6807 5.16218 11.9306 4.41215 11.0054 4.41215L10.796 4.41215C10.4876 4.41215 10.2376 4.66216 10.2376 4.97057L10.2376 6.29681C10.2376 6.60521 10.4876 6.85522 10.796 6.85522L12.1222 6.85522Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIcon);
export default __webpack_public_path__ + "static/media/coin_icon.064636c1652b719dd555922490c11dc4.svg";
export { ForwardRef as ReactComponent };